import Link from "next/link";
import Logo from "@/icons/logo";
import { cn } from "@/lib/utils";

export function HomeLogoLink({ className }: { className?: string }) {
  return (
    <Link
      aria-label="Home"
      className={cn("flex items-center gap-2", className)}
      href="/"
    >
      <Logo animated className="text-gray-1200" />
    </Link>
  );
}
